import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import routing from "routing";
import Box from "src/components/Default/Main/Box";
import { UserDeckCard } from "src/components/NewComponents/Flashcards/UserDecks/UserDeckCard";
import FlashcardsSkeletons from "src/components/NewComponents/Skeletons/ExamsShortView";
import type { SearchDeck } from "src/hooks/useFlashcards";
import { useGetUserDecks } from "src/hooks/useFlashcards";
import FlashcardIcon from "src/images/Icons/newIcons/navigation/flashcards.svg";

import { hasLimitedAccess } from "../../helpers/getPermissions";
import isMobile from "../../helpers/isMobile";
import EmptyBox from "../Main/EmptyBox";
import { ShortLimitedAccess } from "../NewComponents/LimitedAccess";
import { Header } from "./ExamsBox/ExamsBox";

function NewDeck() {
	const { t } = useTranslation();
	const history = useHistory();
	const { isLoading, data: decks } = useGetUserDecks();

	const renderContent = () => {
		if (isLoading) {
			return <FlashcardsSkeletons />;
		}

		if (hasLimitedAccess()) {
			return <ShortLimitedAccess />;
		}

		if (!decks || decks.length === 0) {
			return (
				<EmptyBox
					title={t("table.decks.empty.title")}
					subtitle={t("table.decks.empty.submitText")}
				/>
			);
		}

		let decksToShow = decks.filter((deck: { count: number }) => deck.count > 0);

		if (!decksToShow.length) {
			decksToShow = decks;
		}

		return decksToShow
			.slice(0, isMobile() ? 1 : 2)
			.map((deck: SearchDeck) => (
				<UserDeckCard deck={deck} className="mb-8" key={deck.code} />
			));
	};

	return (
		<Box
			showAllLink={routing.paths.userDecks}
			Header={
				<Header
					title={t("table.decks.title")}
					icon={<FlashcardIcon className={cx("icon-super-big icon-purple")} />}
					onShowAll={() => {
						history.push(routing.paths.userDecks);
					}}
					onCreate={() => {
						history.push(routing.paths.pickFlashcardsDeckChoice);
					}}
					onCreateTooltip={t("tooltips.createNewDeck")}
					onShowAllTooltip={t("tooltips.showAllDecks")}
				/>
			}
		>
			{renderContent()}
		</Box>
	);
}

export default NewDeck;
